import axios from "axios";
import { baseURL } from "../../constants/Api";

export const fetch_all_propmotions = async (hotelId, id) => {
  let config = {
    method: "post",
    url: `${baseURL}/api/promotions`,
    headers: {
      Accept: "application/json",
    },
    data: {
        hotelId,
        id
    },
  };

  try {
    const response = await axios.request(config);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
